// src/pages/Contact.js
import React, { useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';
import apiClient from '../api/apiClient';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { FaCalendarDay, FaRegCreditCard, FaUserFriends, FaUserTie } from "react-icons/fa";

import { useDispatch } from 'react-redux'
import { CustomLoader } from '../services/Reducer'
import { LiaQrcodeSolid } from 'react-icons/lia';
import { RiMoneyRupeeCircleLine } from 'react-icons/ri';
import { GiMoneyStack, GiWallet } from 'react-icons/gi';
import { FaMoneyCheckDollar } from 'react-icons/fa6';
import authServices from '../services/AuthServices';


const Dashboard = () => {

  const [series1, setseries1] = useState(0);
  const [series2, setseries2] = useState(0);
  const [series3, setseries3] = useState('0.0');
  const [series4, setseries4] = useState('0.0');
  const [series5, setseries5] = useState('0.0');
  const [series6, setseries6] = useState('0.0');
  const [series7, setseries7] = useState('0.0');
  const [series8, setseries8] = useState('0.0');


  //**********************************************   Main Big chart 5   *****************************************************************

  const [chartOptions5, setChartOptions5] = useState({
    chart: {
      id: 'basic-bar',
      type: 'area',
      toolbar: {
        show: false, // Disable the toolbar with all menu items
      },
      offsetX: 0, // Chart ko left side se closer laane ke liye
      offsetY: 50,  // Upar se space badhane ke liye
    },

    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996],
      labels: {
        show: false, // X-axis labels (1, 2, 3) ko hide karna
      },
    },
    yaxis: {
      labels: {
        show: false, // Y-axis labels (20, 40, 60) ko hide karna
      },
    },
  });

  const [series9, setseries9] = useState([
    {
      amount: [], // Amount ko ek array mein store karenge
      date: [], // Date ko bhi ek array mein store karenge
    },
  ]);


  //*********************************************  Flatpicker Calender ****************************************************************** 

  // Date Picker useEffect
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loader = (display) => { dispatch(CustomLoader(display)) }
  const [selectedDate, setSelectedDate] = useState([]);

  useEffect(() => {
    loader('disable');

    // Default date range (last 29 days)
    const today = new Date();
    const last4Week = new Date(today);
    last4Week.setDate(today.getDate() - 29);

    // Set default date range if not already set
    if (selectedDate.length === 0) {
      setSelectedDate([last4Week, today]);
    }

    if (inputRef.current) {
      const fp = flatpickr(inputRef.current, {
        mode: "range",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            setSelectedDate(selectedDates); // Set the selected date range

          }
        },
      });

      return () => {
        fp.destroy();
      };
    }
  }, []);

  const formatDate = (date) => {

    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;

  };

  //********************************************* API se data fetch karna ***************************************************************

  const [apiData, setApiData] = useState(null);

  const token = authServices.getToken();
  const fetchData = async () => {
    try {

      setseries1(0);
      setseries2(0);
      setseries3('0.0');
      setseries4('0.0');
      setseries5('0.0');
      setseries6('0.0');
      setseries7('0.0');
      setseries8('0.0');

      setseries9([
        {
          date: [],
          amount: [],
        },
      ]);

      const formattedFromDate = formatDate(new Date(selectedDate[0])),
        formattedToDate = formatDate(new Date(selectedDate[1]));

      const response = await apiClient.get('/api/admin/count/all', {
        params: {
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        },

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === 'SUCCESS') {
        setApiData(response.data.data);
        // console.log("Graph ka Data ", response.data.data)
        // Check if graph data exists and is valid
        // Extract the graph data

        const graphData = response.data.data.graph;

        // Separate amounts and dates
        const amounts = graphData.map(item => item.amount);
        const dates = graphData.map(item => item.date);

        setseries9([
          {
            amount: amounts, // Ensure it's a valid array
            date: dates,     // Ensure it's a valid array
          },
        ]);

        setseries1(response.data.data.no_of_operator)
        setseries2(response.data.data.no_of_users)
        setseries3(response.data.data.total_QR)
        setseries4(response.data.data.total_card)
        setseries5(response.data.data.total_cash)
        setseries6(response.data.data.total_collection)
        setseries7(response.data.data.total_dd)
        setseries8(response.data.data.total_wallet_load)


        console.log(response.data.data)

      }
      else {
        console.log(response.data.message)

      }
    } catch (error) {
      // Log error to the console
      console.error("Error fetching services:", error.response?.data?.message || "Error fetching services");
    }
  };

  useEffect(() => {

    if (selectedDate[0] && selectedDate[1]) {
      fetchData();
    }

  }, [selectedDate]);

  // ***********************************************************************************************************************************

  return (
    <>
      {/* <div className="row"> */}
      {/* <div className="col-lg-12"> */}
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="container-fluid">
              {/* start page title */}
              <div className="d-flex justify-content-between">
                <h4 className="font-size-20">Dashboard</h4>


                <div className="d-flex align-items-center gap-1 mb-3">

                  <div className="input-group datepicker-range" >
                    <input
                      ref={inputRef}
                      className="form-control flatpickr-input input"
                      type="text"
                      value={
                        selectedDate.length === 2 && selectedDate[0] && selectedDate[1]
                          ? `${formatDate(selectedDate[0])} - ${formatDate(selectedDate[1])}`
                          : "" // Empty input initially
                      }
                      onChange={(e) => {
                        const dateRange = e.target.value.split(" - ");
                        const startDate = dateRange[0] ? new Date(dateRange[0].split('-').reverse().join('-')) : null;
                        const endDate = dateRange[1] ? new Date(dateRange[1].split('-').reverse().join('-')) : null;

                        setSelectedDate([startDate, endDate]);

                      }}
                      placeholder="Filter By Date"
                    />

                    <button className="input-group-text" id="date1">
                      <FaCalendarDay />
                    </button>

                  </div>
                </div>

              </div>


              {/* end page title */}
              <div className="row">

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate">

                            {/* <b>Operators</b> */}
                            <abbr title="Operators " style={{ textDecoration: 'none' }}><b>Operators </b></abbr>

                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {series1 || "0"}
                              {/* {(series1/1000).toFixed(2) || "0.0"} K */}
                            </span>
                            {/* % */}
                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          {/* <Chart
                      options={chartOptions}
                      series={series}
                      type="line"
                      width="130%"
                      height="100"
                    /> */}

                          <FaUserTie />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate">

                            {/* <b>Employees</b> */}
                            <abbr title="Employees " style={{ textDecoration: 'none' }}><b>Employees </b></abbr>

                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {series2 || "0"}
                              {/* {(series2/1000).toFixed(2) || "0.0"} K */}
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <FaUserFriends />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate">

                            {/* <b>UPI Collection </b> */}
                            <abbr title="UPI Collection " style={{ textDecoration: 'none' }}><b>UPI Collection </b></abbr>

                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {/* {series3 || "0.0"} */}
                              {(series3 / 1000).toFixed(2) || "0.0"} K
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <LiaQrcodeSolid />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate">

                            {/* <b>Card Collection</b> */}
                            <abbr title="Card Collection" style={{ textDecoration: 'none' }}><b>Card Collection</b></abbr>

                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {/* {series4 || "0.0"} */}
                              {(series4 / 1000).toFixed(2) || "0.0"} K
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <FaRegCreditCard />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>


                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh- d-block text-truncate">

                            {/* <b>Cash Collection</b> */}
                            <abbr title="Cash Collection" style={{ textDecoration: 'none' }}><b>Cash Collection</b></abbr>


                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {/* {series5 || "0.0"} */}
                              {(series5 / 1000).toFixed(2) || "0.0"} K
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <RiMoneyRupeeCircleLine />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate">

                            {/* <b>Total Collection</b> */}
                            <abbr title="Total Collection" style={{ textDecoration: 'none' }}><b>Total Collection</b></abbr>


                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {/* {series6 || "0.0"} */}
                              {(series6 / 1000).toFixed(2) || "0.0"} K
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <GiMoneyStack />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate">

                            {/* <b>DD Collection</b> */}
                            <abbr title="DD Collection" style={{ textDecoration: 'none' }}><b>DD Collection</b></abbr>


                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {/* {series7 || "0.0"} */}
                              {(series7 / 1000).toFixed(2) || "0.0"} K
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <FaMoneyCheckDollar />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>

                <div className="col-xl-3 col-md-6">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-6">
                          <span className=" mb-3 lh-3 d-block text-truncate" >

                            <abbr title="Total Wallet Recharge" style={{ textDecoration: 'none' }}><b>Total Wallet Recharge</b></abbr>

                          </span>
                          <h4 className="mb-3">
                            <span className="counter-value" data-target="12.57">
                              {(series8 / 1000).toFixed(2) || "0.0"} K
                            </span>

                          </h4>
                        </div>
                        <div className="col-6 GraphIcon">
                          <GiWallet />
                        </div>
                      </div>
                      <div className="text-nowrap">
                        <span className="badge bg-success-subtle text-success">
                          +2.95%
                        </span>
                        <span className="ms-1 text-muted font-size-13">
                          Showing Some Info
                        </span>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>

                {/* end col */}
              </div>
              {/* end row*/}
              <div className="row">
                <div className="col-xl-5">
                  {/* card */}
                  <div className="card card-h-100">
                    {/* card body */}
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-center mb-4 ms-4">
                        <h5 className="card-title me-5">Wallet Balance</h5>

                        <div className='row align-items-center '>
                          <div className='col-sm'>
                            <Chart
                              className="responsive-chart"
                              options={{
                                ...chartOptions5,
                                xaxis: {
                                  categories: series9[0].date.length ? series9[0].date : [], // Ensure dates are available
                                },
                              }}
                              series={[
                                {
                                  name: 'Amount',
                                  data: series9[0].amount.length ? series9[0].amount : [], // Ensure amount data is available
                                },
                              ]}
                              type="area" // Graph type specify karein
                              height="220"
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* end card */}


                </div>
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* container-fluid */}

          </div>

        </div>
      </div>
      {/* </div> */}
      {/* </div> */}

    </>
  );
};

export default Dashboard;
